import styled, { css } from 'styled-components'

const Container = styled.div`
  ${({ theme: { breakpoints, containerMaxWidth }}) => css`
    margin: 0 auto;
    padding: 0 1.6rem;
    max-width: 100%;
    @media (min-width: ${breakpoints.sm}px) {
      max-width: ${containerMaxWidth.sm}px;
    }
    @media (min-width: ${breakpoints.md}px) {
      max-width: ${containerMaxWidth.md}px;
    }
    @media (min-width: ${breakpoints.lg}px) {
      max-width: ${containerMaxWidth.lg}px;
    }
    // @media (min-width: ${breakpoints.xl}px) {
    //   max-width: ${containerMaxWidth.xl}px;
    // }
  `}
`

export default Container